// src/contexts/LanguageContext.js
import React, { createContext, useState, useContext } from 'react';

// 컨텍스트 생성
const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const getBrowserLanguage = () => {
    const savedLanguage = localStorage.getItem('preferredLanguage');
    if (savedLanguage) return savedLanguage;
    const browserLang = navigator.language || navigator.userLanguage;
    return browserLang && browserLang.startsWith('ko') ? 'ko' : 'en';
  };

  const [language, setLanguage] = useState(getBrowserLanguage());

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('preferredLanguage', lang);
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

// 컨텍스트를 사용하기 위한 커스텀 훅
export const useLanguage = () => useContext(LanguageContext);
